import UrlApi from './urlApi'

const getLocateReserve = (reserve, result) => {
	return fetch(`${UrlApi}/order/${reserve}`)
	.then(res => result(res))
}

export default getLocateReserve



// WEBPACK FOOTER //
// ./src/shared/lib/locateReserve.js